module.exports = __webpack_public_path__ + "f75547a0632ffe9be3d5c1aeec085563.svg";